export { default as Gtm } from './src/gtm';
export { default as useGtmId } from './src/useGtmId';
